// extracted by mini-css-extract-plugin
export default {"wrapper":"qdMbeKB68s0WZ+x7B66xlw==","errorIllustration":"sFh-IQgCUgyyr87w-daQAA=="};